import { inject, Injectable, Renderer2, RendererFactory2, signal } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { HamburgerMenuComponent } from './hamburger-menu/hamburger-menu.component';
import { filter } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { ServiceRequestService } from '../services/service-request/service-request.service';

export const napsButtons: naps_Button[] = [
  { name: 'Candidate', routeLink: '/candidate-login' },
  { name: 'Establishment', routeLink: '/establishment-registration' },
  { name: 'Third Party Aggregator', routeLink: '/tpa-registration' },
  { name: 'Basic Training Provider(BTP)', routeLink: '/btp-registration' },
  { name: 'Other Admins', routeLink: '/login' }
];

export const LoginButton: naps_Button = {
  name: 'Login/Register',
  routeLink: '/'
};
export const DashBoardButton: naps_Button = {
  name: 'Dashboard',
  routeLink: 'https://app.powerbi.com/view?r=eyJrIjoiNzhiMDMyODQtYmVjZi00ZWY2LThlM2UtY2UzMDUzN2RjMWEwIiwidCI6IjcyNGI4ZWQxLTgxODMtNGNiOS1iNWIwLTFlZDY3YWZlYWNmMSIsImMiOjEwfQ%3D%3D'
};
export const MelaButton: naps_tag_Button = {
  name: 'Apprenticeship Mela',
  routeLink: '/pmnam-map',
};
export const LogOut: naps_Button = {
  name: 'Logout',
  routeLink: '/'
}
export type naps_tag_Button = {
  name: string,
  routeLink: string,
}
export type naps_Button = {
  name: string,
  routeLink: string
}
@Injectable({
  providedIn: 'root'
})
export class HamburgerStateService {
  menuData = {
    mainMenu: [
      // {
      //   name: 'Home ',
      //   url: '/',
      //   isRoutable: true,
      //   hasSubMenu: false,
      //   hasNextedMenu: false,
      //   isdownload: false
      // },
      // {
      //   name: 'About',
      //   url: '/',
      //   hasSubMenu: true,
      //   hasNextedMenu: false,
      //   isdownload: false,
      //   doNothing: true ,
      //   subMenu: [
      //     { name: 'Apprentices Act, 1961', url: '/#apprentices-act-1961', isdownload: false, isRoutable: true , doNothing: false  },
      //     { name: 'PM-NAPS', url: '/#pm-naps', isdownload: false, isRoutable: true , doNothing: false  }
      //   ]
      // },
      {
        name: 'Services',
        url: '/',
        hasSubMenu: true,
        hasNextedMenu: false,
        isdownload: false,
        doNothing: true ,
        subMenu: [
          { name: 'Download Marksheet/Certificate – Designated Trades', url: '/apprentice/services', isdownload: false, isRoutable: true },
          { name: 'Download COP – Optional Trades', url: '/apprentice/services/cop', isdownload: false, isRoutable: true },
          { name: 'Download Legacy Certificate – Designated Trades', url: '/apprentice/services/legacy-certificate', isdownload: false, isRoutable: true},
          { name: 'Download Legacy Certificate & Marksheet (after 2018)', url: '/apprentice/services/legacy-certificate-new', isdownload: false, isRoutable: true}
        ]
      },
      // {
      //   name: 'Apprenticeship Opportunities',
      //   url: '/apprenticeship/opportunity',
      //   isRoutable: true,
      //   hasNextedMenu: false,
      //   hasSubMenu: false,
      //   isdownload: false
      // },
      {
        name: 'Courses',
        url: '/courses',
        isRoutable: true,
        hasSubMenu: false,
        hasNextedMenu: false,
        isdownload: false
      },
      {
        name: 'Opportunities',
        url: '/apprenticeship/opportunity',
        isRoutable: true,
        hasSubMenu: false,
        hasNextedMenu: false,
        isdownload: false
      },
      {
        name: 'TPA',
        tooltip: 'Third Party Aggregator (TPA)',
        url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/TPA+contact+list_updated+October+2025.pdf',
        isRoutable: false,
        hasSubMenu: false,
        hasNextedMenu: false,
        isdownload: true,
        doNothing: false
      },
      {
        name: 'Help and Support',
        url: '/',
        hasSubMenu: true,
        isRoutable: false,
        isdownload: false,
        doNothing:true,
        subMenu: [
          { name: 'FAQ', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/Updated+Faq.pdf',hasNextedMenu: false, isdownload: true,  isRoutable: false ,  doNothing:false },
          { name: 'DBT FAQ', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/NAPS_DBT_Communication_Plan_and_FAQs_26th+September\'23.pdf',hasNextedMenu: false, isdownload: true,  isRoutable: false ,  doNothing:false },
          {
            name: 'Call Us',
            isRoutable: false,
            isdownload: false,
            hasNextedMenu: true,
            nextedMenu: [
              { name: '8800055555', url: 'https://www.youtube.com/watch?v=8_rKnGtk474&feature=youtu.be', isdownload: false, isRoutable: false, doNothing:true, isTitle:false },
              { name: '18001239626', url: 'https://www.youtube.com/watch?v=9yTwtCSZkmc&feature=youtu.be', isdownload: false, isRoutable: false, doNothing:true, isTitle:false },
            ]
          },
          { name: 'Technical Support', url: 'https://support.nsdcindia.org/portal/en/signin',hasNextedMenu: false, isdownload: false,  isRoutable: false ,  doNothing:false },
          {
        name: 'Instructional Videos',
        url: '/',
        hasNextedMenu: true,
        isRoutable: false,
        isdownload: false,
        doNothing: true ,
        nextedMenu: [
          { name: 'Introduction to Apprenticeship Portal', url: 'https://youtu.be/EWto9YJ-3Ws' , isdownload: false, isRoutable: false , doNothing: false },
          {
            name: 'Candidate',
            isRoutable: false,
            isdownload: false,
            hasNestedSubMenu: true,
            nestedSubMenu: [
              // { name: 'Know My Rights', url: 'https://www.youtube.com/watch?v=EWto9YJ-3Ws&feature=youtu.be&themeRefresh=1', isdownload: false, isRoutable: false , doNothing: false },
              { name: 'English', url: 'https://youtu.be/0dt82kfvbQ4', isdownload: false, isRoutable: false , doNothing: false , isTitle:true, isVideoOnTitle: true,
                hasNestedSubMenu:true,
                nestedSubMenu:[
                  { name: 'Registration', url: 'https://youtu.be/UgiPyeEgbik?si=lRdL29ajZuJNIb1p', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Complete Profile & e-KYC', url: 'https://youtu.be/VyoEu0nHGdo?si=M6lWFKuypOAUO4a0', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Apply for Opportunities', url: 'https://youtu.be/eX7v24F8r7o?si=01Xb45yBHGbAro4e', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Contract Signing', url: 'https://youtu.be/pFz5ZqhZXOM?si=G8GEc2TM4WXfVvFi', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Stipend Tracking ', url: 'https://youtu.be/Gylr8kx-5nA?si=yA4iqQB2VzpxmmQy', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Beneficiary ID Creation', url: 'https://youtu.be/Fy-cU2BUV3g',  isdownload: false, isRoutable: false , doNothing: false, isTitle:false }
                ]
               },
               { name: 'हिन्दी', url: 'https://youtu.be/M-deiGe09RI?si=ivVzwMZudbm73Vnu', isdownload: false, isRoutable: false , doNothing: false , isTitle:true, isVideoOnTitle: true,
                hasNestedSubMenu:true,
                nestedSubMenu:[
                  { name: 'रेजिस्ट्रशन', url: 'https://www.youtube.com/watch?v=E7LhD68vM2o&feature=youtu.be', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'प्रोफाइल कम्पलीशन', url: 'https://www.youtube.com/watch?v=2GqZLME-IJk&feature=youtu.be', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'ओप्पोर्तुनिटीज़', url: 'https://www.youtube.com/watch?v=5law4oIpQtA&feature=youtu.be', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'कॉन्ट्रैक्ट', url: 'https://www.youtube.com/watch?v=VJo_r93C7s0&feature=youtu.be', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'बैंक डिटेल्स', url: 'https://www.youtube.com/watch?v=6B4JAPEeII4&feature=youtu.be', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                ]
              }
            ]
          },
          {
            name: 'Establishments',
            isRoutable: false,
            isdownload: false,
            hasNestedSubMenu: true,
            nestedSubMenu: [
              // { name: 'Know My Rights', url: 'https://www.youtube.com/watch?v=EWto9YJ-3Ws&feature=youtu.be&themeRefresh=1', isdownload: false, isRoutable: false , doNothing: false },
              { name: 'English', url: 'https://www.youtube.com/watch?v=i-qqnS_fRjo', isdownload: false, isRoutable: false , doNothing: false , isTitle:true, isVideoOnTitle: true,
                hasNestedSubMenu:true,
                nestedSubMenu:[
                  { name: 'Registration', url: 'https://www.youtube.com/watch?v=yGXkSDFRSCQ', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Profile Completion', url: 'https://www.youtube.com/watch?v=Z35j-mo6qIo', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Create Opportunities', url: 'https://www.youtube.com/watch?v=nS3rGf0-OUg', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Contract Issue', url: 'https://www.youtube.com/watch?v=HqAgD8yXex8', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Stipend & Payment', url: 'https://www.youtube.com/watch?v=3KPrHpMeAwQ&list=PLEI17o2xGcHBnzkW1PxqffVaKCM6vigV5&index=5', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Reimbursement', url: 'https://www.youtube.com/watch?v=sI8tJTlFHo8&list=PLEI17o2xGcHBnzkW1PxqffVaKCM6vigV5&index=6', isdownload: false, isRoutable: false , doNothing: false, isTitle:false }
                ]
               },
               { name: 'हिन्दी', url: 'https://youtu.be/ipPhQ1dGgsY', isdownload: false, isRoutable: false , doNothing: false , isTitle:true, isVideoOnTitle: true,
                hasNestedSubMenu:true,
                nestedSubMenu:[
                  { name: 'रजिस्ट्रेशन', url: 'https://www.youtube.com/watch?v=xTj5Ss1tcw8&list=PLEI17o2xGcHCtqJvEYQpTueA3Dan9YKbP&index=1', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'रोफाइल कम्पलीशन', url: 'https://www.youtube.com/watch?v=mHlJeD2QL2g&list=PLEI17o2xGcHCtqJvEYQpTueA3Dan9YKbP&index=2', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'क्रिएट ओप्पोरचुनिटी', url: 'https://www.youtube.com/watch?v=VpeJRt75ypM&list=PLEI17o2xGcHCtqJvEYQpTueA3Dan9YKbP&index=3', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'कॉन्ट्रैक्ट इशू', url: 'https://www.youtube.com/watch?v=9WLFyHhdHGE&list=PLEI17o2xGcHCtqJvEYQpTueA3Dan9YKbP&index=4', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'स्टाइपेंड पेमेंट', url: 'https://www.youtube.com/watch?v=W4ylXucdfp0&list=PLEI17o2xGcHCtqJvEYQpTueA3Dan9YKbP&index=5', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'रीमबर्समेंट', url: 'https://www.youtube.com/watch?v=bN6jcZSEGiA&list=PLEI17o2xGcHCtqJvEYQpTueA3Dan9YKbP&index=6', isdownload: false, isRoutable: false , doNothing: false, isTitle:false }
                ]
              }
            ]
          },
          {
            name: 'TPA',
            isRoutable: false,
            isdownload: false,
            hasNestedSubMenu: true,
            nestedSubMenu: [
              { name: 'English', url: '', isdownload: false, isRoutable: false , doNothing: false , isTitle:true,
                hasNestedSubMenu:true,
                nestedSubMenu:[
                  { name: 'Registration', url: 'https://www.youtube.com/watch?v=z66-Hy0beN8&list=PLEI17o2xGcHCS8T0epL5Igh4pSlm1TwBk&index=1', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Profile Completion', url: 'https://www.youtube.com/watch?v=y5Hu6ys_cu0&list=PLEI17o2xGcHCS8T0epL5Igh4pSlm1TwBk&index=2', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Association with Establishment', url: 'https://www.youtube.com/watch?v=VfE_XA7-DuI&list=PLEI17o2xGcHCS8T0epL5Igh4pSlm1TwBk&index=3', isdownload: false, isRoutable: false , doNothing: false, isTitle:false }
                ]
               },
               { name: 'हिन्दी', url: '', isdownload: false, isRoutable: false , doNothing: false , isTitle:true,
                hasNestedSubMenu:true,
                nestedSubMenu:[
                  { name: 'रजिस्ट्रेशन', url: 'https://www.youtube.com/watch?v=BUiiPzrNkZQ&list=PLEI17o2xGcHDkFhOTfm5j-H1Gg_PE8R2o&index=1', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'प्रोफाइल कम्पलीशन<', url: 'https://www.youtube.com/watch?v=ZttznWcnglw&list=PLEI17o2xGcHDkFhOTfm5j-H1Gg_PE8R2o&index=2', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'एसोसिएशन विथ इस्टैब्लिशमेंट', url: 'https://www.youtube.com/watch?v=7Z_aerEROfU&list=PLEI17o2xGcHDkFhOTfm5j-H1Gg_PE8R2o&index=3', isdownload: false, isRoutable: false , doNothing: false, isTitle:false }
                ]
              }
            ]
          },
          { name: 'AAA', url: 'https://www.youtube.com/watch?v=Qc_6IhBFwzA' , isdownload: false, isRoutable: false , doNothing: false },
          {
            name: 'DBT Videos',
            isRoutable: false,
            isdownload: false,
            hasNestedSubMenu: true,
            nestedSubMenu: [
              { name: 'Candidate', url: '', isdownload: false, isRoutable: false , doNothing: false , isTitle:true,
                hasNestedSubMenu:true,
                nestedSubMenu:[
                  { name: 'Profiling including DBT - English', url: 'https://youtu.be/P5J19JSJcb4', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'DBT Process - English', url: 'https://youtu.be/y6_Cmm3AzA4', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                ]
               },
               { name: 'Establishments', url: '', isdownload: false, isRoutable: false , doNothing: false , isTitle:true,
                hasNestedSubMenu:true,
                nestedSubMenu:[
                  { name: 'DBT Process - Hindi', url: 'https://youtu.be/A1pDaVDoRkA', isdownload: false, isRoutable: false , doNothing: false, isTitle:false },
                  { name: 'Profiling including DBT - Hindi', url: 'https://youtu.be/9Uwqy8iJbXE', isdownload: false, isRoutable: false , doNothing: false, isTitle:false }
                ]
              }
            ]
          }
        ]
          },
        ]
      },
      {
        name: 'Public Gallery',
        url: '/testimonials/view-all',
        isRoutable: true,
        hasSubMenu: false,
        hasNextedMenu: false,
        isdownload: false,
        doNothing: false
      }
      // {
      //   name: `FAQ's`,
      //   url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/Apprenticeship_FAQs.pdf',
      //   isRoutable: false,
      //   isdownload: true,
      //   hasSubMenu: false,
      //   hasNextedMenu: false,
      // },
    ]
  };


  userManuals = [
    { name: 'Candidate User Manual', url: 'https://s3.ap-south-1.amazonaws.com/naps-cdn/candidate-manual.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'Establishment User Manual', url: 'https://s3.ap-south-1.amazonaws.com/naps-cdn/establishment-manual.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'Optional Course Manual', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/OT-Course-Instructional-Manual.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'Payroll and Claim Reimbursement', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/Establishment_Payment_v25.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'BTP-TC User Manual', url: 'https://s3.ap-south-1.amazonaws.com/naps-cdn/btp-tp-instructional-guide.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'BTP Reimbursement User Manual', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/BTP_Claims_%26_Reimbursement_Manual.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'Assessment & Certification - OT User Manual', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/AnC_OT_User_Manual.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'Apprenticeship Instructional Videos', url: 'https://www.youtube.com/channel/UCEdgh8fiXmD4aN0U4bui9iA/playlists', isdownload: false, isRoutable: false , doNothing: false  },
    { name: 'DBT Payroll Candidate Registration Manual', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/DBT_Payroll_Candidate_Registration_v9.docx.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'DBT Payroll Establishment Manual', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/DBT_Payroll_Establishment_v8.docx.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'User Manual for AAA Admin - PMNAM', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/AAA_PMNAM_v3.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'User Manual for Establishment Registration - PMNAM', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/Establishment_Registration_PMNAM_v6.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'User Manual for NSDC Admin - PMNAM', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/NSDC_Admin_PMNAM_v9.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'User Manual for RDSDE - PMNAM', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/RDSDE_PMNAM_v9.pdf', isdownload: true, isRoutable: false , doNothing: false  },
    { name: 'User Manual for SAA Admin - PMNAM', url: 'https://naps-cdn.s3.ap-south-1.amazonaws.com/SAA_PMNAM_v5.pdf', isdownload: true, isRoutable: false , doNothing: false  }
  ];

  buttons = {
    login: {
      dropDown: napsButtons,
      key: LoginButton
    },
    mela: MelaButton,
    dashBoard: DashBoardButton,
    logout: LogOut
  };

  private overlayRef: OverlayRef | null = null;
  private overlay = inject(Overlay);
  private renderer: Renderer2;
  isHamburger = signal<boolean>(false);
  headerHeight = signal<number>(83);
  isUserLoggedIn = signal<boolean>(false);

  private readonly PUBLIC_GALLERY_MENU_ITEM = {
    name: 'Public Gallery',
    url: '/testimonials/view-all',
    isRoutable: true,
    hasSubMenu: false,
    hasNextedMenu: false,
    isdownload: false,
    doNothing: false
  };

  constructor(private rendererFactory: RendererFactory2,
    private router: Router,
    private serviceRequestService: ServiceRequestService) {
    this.renderer = rendererFactory.createRenderer(null, null);

    // Close menu on route change
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe(() => {
      this.closeHamburgerMenu();
    });

    this.applyPublicGalleryVisibility();
  }

  private applyPublicGalleryVisibility(): void {
    this.serviceRequestService.getFeatureAccess().subscribe({
      next: (res: any) => {
        const features = res?.data || res || [];
        const publicFeature = Array.isArray(features)
          ? features.find((feature: any) => feature?.feature_name === 'testimonial_public_visibility')
          : null;
        const index = this.menuData.mainMenu.findIndex((item: any) => item.name === 'Public Gallery');

        if (publicFeature?.access === true) {
          if (index === -1) {
            this.menuData.mainMenu.push(this.PUBLIC_GALLERY_MENU_ITEM);
          }
        } else if (index > -1) {
          this.menuData.mainMenu.splice(index, 1);
        }
      },
      error: () => {},
    });
  }
  setHeaderHeight(height: number) {
    this.headerHeight.set(height);
  }

  toggleHamburger() {
    this.isHamburger.set(!this.isHamburger());
  }

  openHamburgerMenu(viewContainerRef: any) {
    if (this.overlayRef) return;
    this.renderer.addClass(document.body, 'hamburger-open');

    const positionStrategy = this.overlay.position()
      .global()
      .top(`${this.headerHeight()}px`)
      .left('0')
      .width('100%')
      .height(`calc(100vh - ${this.headerHeight()}px)`);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'transparent-backdrop',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      panelClass:'custom-hamburger-overlay-panel'
    });

    this.overlayRef.backdropClick().subscribe(() => {
      this.isHamburger.set(false);
    });

    const portal = new ComponentPortal(HamburgerMenuComponent, viewContainerRef);
    this.overlayRef.attach(portal);

  }

  closeHamburgerMenu() {
    this.isHamburger.set(false);
    this.renderer.removeClass(document.body, 'hamburger-open');
    this.overlayRef?.detach();
    this.overlayRef = null;
  }
}
